import lgVideo from "lightgallery/plugins/video";

//* lightGallery's video plugin, except YouTube slides render a placeholder that the
//* privacy--cookie-iframe-manager controller swaps for the iframe once cookies are accepted.
//* Pages without a privacy--cookie-policy controller (e.g. GoThassos) have nothing to do the
//* swap, so they get the stock iframe.
// TODO: Implement cookie consent on GoThassos like the public GT site has, then drop the hasCookiePolicy fallback.
export default class extends lgVideo {
  getVideoHtml(src, addClass, index, html5Video) {
    const videoInfo = this.core.galleryItems[index].__slideVideoInfo || {};
    const hasCookiePolicy = document.querySelector("[data-controller~='privacy--cookie-policy']");

    if (!videoInfo.youtube || !hasCookiePolicy) {
      return super.getVideoHtml(src, addClass, index, html5Video);
    }

    return `
      <div
        data-controller="privacy--cookie-iframe-manager"
        data-service="youtube"
        data-id="${videoInfo.youtube[1]}"
        data-autoscale
        data-iframe-class="lg-video-object lg-youtube ${addClass}"
        data-iframe-id="lg-youtube${index}"
        data-iframe-frameborder="0">
      </div>
    `;
  }
}
